module.exports = __webpack_public_path__ + "img/25yrs.ef322acd.png";